import {Vue} from '~/addiesaas'

import ThumbnailComponent from './thumbnail-component'

const requires = {
    ThumbnailComponent,
}

Object.values(requires).forEach(component => {
    Vue.component(component.name, component)
})

export default requires
